import './ProcessSection.css'

const steps = [
  { num: '01', title: 'Descoberta', desc: 'Imersão no contexto, regras e desafios reais.' },
  { num: '02', title: 'Estratégia', desc: 'Arquitetura, stack e roadmap orientado a valor.' },
  { num: '03', title: 'Construção', desc: 'Desenvolvimento iterativo com entregas frequentes.' },
  { num: '04', title: 'Evolução', desc: 'Suporte, indicadores e melhoria contínua.' },
]

export default function ProcessSection() {
  return (
    <section className="section process-section">
      <div className="section-inner">
        <div className="section-eyebrow">Como trabalhamos</div>
        <h2 className="section-title">Um processo claro, do diagnóstico à entrega</h2>
        <div className="process-steps">
          {steps.map((s) => (
            <div className="step" key={s.num}>
              <div className="step-num">{s.num}</div>
              <h5>{s.title}</h5>
              <p>{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
